import { plural, type WaitingFyi } from '../ui';

/**
 * E1.empty: with no election open, Waiting on you notes that there's nothing to decide and offers
 * the Elections tab's preview of the calculator (APP-093). A note, never counted as waiting.
 */
export function electionFyi(windowDays: number | undefined): WaitingFyi {
  const window = windowDays === undefined ? 'a few days' : plural(windowDays, 'day', 'days');
  return {
    id: 'fyi:election-preview',
    label: 'Cash or stock: nothing to decide right now',
    text: `If an award lets you choose cash or stock, you’ll have ${window} from its award date. A calculator shows the estimated tax and whole shares for each choice.`,
    icon: 'calendarCheck',
    action: { label: 'Preview the calculator', href: '/my-rewards/elections' },
  };
}
